module.exports = new __parcel__URL__("Charlie_Text-Semibold_Italic.e16d6797.woff").toString();